export default "__VITE_ASSET__B_b6jJsH__"